const getCookie = key => {
	const b = document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`);
	return b ? b.pop() : null;
};

export function getUserCountryBasedOnGeo() {
	const cookie = getCookie('GEO_COUNTRY');
	return cookie || null;
}

export function getJwtUserId() {
	// If the user has a jwt-token in it's cookie, we can try to receive the users id from it.
	const authCookie = getCookie('ember_simple_auth-session');
	if (authCookie) {
		try {
			const jwtToken = JSON.parse(window.atob(decodeURIComponent(authCookie).split('.')[1]));
			const userId = jwtToken.rid;
			return userId;
		} catch (error) {
			// noop
		}
	}

	return null;
}
